<template>
  <div class="col row items-center justify-between relative-position">
    <div
      class="column items-start"
      style="max-width: 432px;"
    >
      <div
        class="text-uppercase"
        :class="{ 'text-grey-4': orderItem.isVoided }"
      >
        <q-chip
          v-if="orderItems.length > 1"
          class="items-start q-ma-none q-mb-xs"
          :label="orderItems.length"
          color="primary"
          :text-color="$isColorDark(currentSite.primaryColor) ? 'white' : 'dark'"
          size="sm"
          dense
        />
        <span class="item-label">
          {{ orderItemItemDisplayName }} | <em>{{ orderItemVariationDisplayName }}</em>
        </span>
        <template
          v-if="kitchenDisplay.kitchenDisplayType.showDeliveryPositions && orderItem.deliveryPositions.length"
        >
          <q-chip
            v-for="position in orderItem.deliveryPositions"
            :key="position"
            class="q-ma-none q-mb-xs q-ml-xs"
            :label="position"
            size="sm"
            dense
          />
        </template>
        <div
          v-if="orderItem.isVoided"
          class="row text-h4 text-bold text-negative absolute-full justify-center items-center"
        >
          VOIDED
        </div>
      </div>
      <div
        v-if="orderItemDescriptionModifiers.length"
        class="q-pl-sm"
        :class="{ 'text-grey-4': orderItem.isVoided }"
      >
        <div
          v-for="(modifier, i) in orderItemDescriptionModifiers"
          :key="'orderItem-modifier-' + i"
          class="modifier-label"
        >
          {{ modifier }}
        </div>
      </div>
    </div>
    <div>
      <q-icon
        v-if="orderItemShowIcon"
        :name="orderItemIconName"
        :color="orderItemIconColor"
        size="md"
        @click.stop="handleIconClick"
      />
      <q-chip
        v-else-if="relativePrepTimeLabel"
        class="text-center q-my-none q-mr-none"
        style="height: 32px; min-width: 32px; max-width: 38px; padding: 0.4em;"
        color="grey-7"
        size="sm"
        outline
      >
        <span class="full-width text-center">
          {{ relativePrepTimeLabel }}
        </span>
      </q-chip>
      <q-icon
        v-if="orderItem.pickPrepPrintedAt"
        name="print"
        color="green"
        size="md"
      />
    </div>
  </div>
</template>

<script>
import { STAGES } from 'src/models/kitchen-display/KitchenDisplayType'
import KitchenCardMixin from 'src/modules/kds/components/kitchen-card/mixins/KitchenCardMixin'
import DeliveryModifierDialog from 'src/modules/register/components/DeliveryModifierDialog'

export default {
  name: 'KitchenOrderItemItem',
  mixins: [KitchenCardMixin],
  configuration: ['currentSite'],
  props: {
    showPrepIcon: {
      type: Boolean,
      required: false,
      default: null
    },
    relativePrepTimeLabel: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
    orderItem () {
      // We use an orderItems array so that all mixin methods can be shared
      return _.first(this.orderItems)
    },
    orderItemItemDisplayName () {
      return this.orderItem.itemOrderItem.item.displayName
    },
    orderItemVariationDisplayName () {
      return this.orderItem.itemOrderItem.itemVariation.name
    },
    orderItemDescriptionModifiers () {
      const modifiers = [...this.orderItem.itemOrderItem?.itemModifierNames || []]

      if (this.orderItem.note) modifiers.push(`Note: ${this.orderItem.note}`)

      return modifiers
    },
    orderItemShowIcon () {
      if (this.tab === STAGES.COMPLETE) return false

      if (this.orderItem.isHeld) return true

      return this.orderItem.isReadyForDelivery || !this.orderItem.item.requiresPreparation || this.showPrepIcon
    },
    orderItemIconColor () {
      if (this.orderItem.isReadyForDelivery) {
        return 'positive'
      } else if (this.orderItem.isHeld && this.currentSite.usePickPrepWaitAndFire) {
        return 'warning'
      } else if (!this.orderItem.item.requiresPreparation) {
        return 'info'
      } else if (this.showPrepIcon) {
        return 'info'
      }
      return null
    },
    orderItemIconName () {
      if (this.orderItem.isReadyForDelivery || !this.orderItem.item.requiresPreparation) {
        return 'done'
      } else if (this.orderItem.isHeld && this.currentSite.usePickPrepWaitAndFire) {
        return 'timer_off'
      } else if (this.showPrepIcon) {
        return 'outdoor_grill'
      }
      return null
    },
    prepTime () {
      return null
    }
  },
  methods: {
    handleIconClick () {
      if (this.orderItem.isHeld && this.currentSite.usePickPrepWaitAndFire) {
        this.$q.dialog({
          component: DeliveryModifierDialog,
          componentProps: {
            order: this.order,
            allowPlaceOrder: false
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .item-label {
    font-size: 18px;
    line-height: 1.375rem;
    max-width: 400px;
  }

  .modifier-label {
    font-size: 17px;
    line-height: 1.375rem;
    max-width: 400px;
  }

  /* Sized to match the order item icon and prepared checkmark */
  .relative-prep-time-chip {
    height: 32px;
    min-width: 32px;
    max-width: 38px;
    padding: 0.4em;
  }
</style>
